import styles from "./TextCode.module.scss";

export const TextCode = ({ textCode }: { textCode: string }) => {
  return <div className={styles.textCode}>{textCode}</div>;
};
